
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { MASKED_ANNOTATION } from 'smartbarcode-web-core/src/utils/constants'
import { IClientInfo } from 'smartbarcode-web-core/src/utils/types'

@Options({ name: 'ClientInfoBlock' })
export default class ClientInfoBlock extends Vue {
  @Prop({ type: Array, required: true }) readonly clients!: IClientInfo[]
  maskedUsers = 1

  get isAuth() {
    return this.$store.getters.isAuth
  }

  get displayItems() {
    if (this.isAuth) {
      return this.clients.map((c) => ({ name: c.name, masked: false }))
    }
    return Array.from({ length: this.maskedUsers }, () => ({ name: MASKED_ANNOTATION, masked: true }))
  }
}
